module.exports = __webpack_public_path__ + "img/privilege9.6d27a973.png";